import React from 'react';

export function calcularProgreso(recaudado: number, objetivo: number): number {
  return objetivo > 0 ? Math.min((recaudado / objetivo) * 100, 100) : 0;
}

export function formatProgreso(recaudado: number, objetivo: number): string {
  return objetivo > 0 ? `${calcularProgreso(recaudado, objetivo).toFixed(0)}%` : '—';
}

interface ProgresoBarProps {
  recaudado: number;
  objetivo: number;
  heightClass?: string;
}

export const ProgresoBar: React.FC<ProgresoBarProps> = ({ recaudado, objetivo, heightClass = 'h-1.5' }) => {
  const pct = calcularProgreso(recaudado, objetivo);
  return (
    <div className={`w-full bg-gray-200 rounded-full ${heightClass} overflow-hidden`}>
      <div
        className="h-full bg-emerald-500 rounded-full transition-all duration-300"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
};
